import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/consultant/page.tsx");
